import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M23.878 1.371a.873.873 0 000-.891.875.875 0 00-.688-.48H.857a.878.878 0 00-.773.48.873.873 0 00.086.891l8.916 11.64c.233.3.36.667.36 1.046v9.086a.856.856 0 00.533.788.74.74 0 00.327.069.81.81 0 00.601-.257l3.436-3.429a.804.804 0 00.258-.6v-5.657c0-.379.128-.746.36-1.046l8.917-11.64z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
